(function () {
  function destroyBrandSwiper(section) {
    if (section.gnrBrandSwiper) {
      section.gnrBrandSwiper.destroy(true, true);
      section.gnrBrandSwiper = null;
    }

    delete section.dataset.gnrBrandReady;
  }

  function initBrandSection(section) {
    destroyBrandSwiper(section);

    var swiperEl = section.querySelector(".gnr26-brand__swiper");
    if (!swiperEl || typeof Swiper === "undefined") return;

    var slideCount = swiperEl.querySelectorAll(".swiper-slide").length;
    if (slideCount <= 1) {
      section.dataset.gnrBrandReady = "true";
      return;
    }

    var prevButton = section.querySelector(".gnr26-brand__nav-button--prev");
    var nextButton = section.querySelector(".gnr26-brand__nav-button--next");

    // Theme pages load Swiper 4.x (max-width breakpoints):
    // base = desktop (>1000), breakpoints[1000] = mobile (<=1000)
    section.gnrBrandSwiper = new Swiper(swiperEl, {
      slidesPerView: 3,
      slidesPerGroup: 3,
      centeredSlides: false,
      initialSlide: 0,
      spaceBetween: 10,
      loop: false,
      speed: 450,
      watchOverflow: true,
      pagination: {
        el: section.querySelector(".gnr26-brand__pagination"),
        clickable: true,
        type: "bullets",
      },
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      breakpoints: {
         1000: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 10,
        },
      },
    });

    section.dataset.gnrBrandReady = "true";
  }

  function initAll() {
    document.querySelectorAll("[data-gnr-brand]").forEach(initBrandSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-gnr-brand]") || event.target;
    if (section.matches("[data-gnr-brand]")) {
      initBrandSection(section);
    }
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.querySelector("[data-gnr-brand]") || event.target;
    if (section.matches("[data-gnr-brand]")) {
      destroyBrandSwiper(section);
    }
  });
})();
